import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import api from "@/lib/api";
import { ArrowRight, Clock } from "lucide-react";

export default function ModulesListPage() {
  const [modules, setModules] = useState([]);
  const [progress, setProgress] = useState({});

  useEffect(() => {
    (async () => {
      const [m, p] = await Promise.all([api.get("/modules"), api.get("/progress")]);
      setModules(m.data);
      setProgress(p.data?.per_module || {});
    })();
  }, []);

  return (
    <AppLayout>
      <div className="px-6 md:px-10 py-10 max-w-6xl mx-auto" data-testid="modules-list-page">
        <div className="overline mb-3">The curriculum</div>
        <h1 className="font-serif text-5xl text-[var(--dw-navy)] mb-4 tracking-tight">Five modules to license.</h1>
        <p className="text-neutral-600 max-w-2xl mb-10">
          Each module contains structured readings, one lecture video from the official SAFE MLO
          test bank, and a knowledge-check assessment. Score 85% or higher to complete.
        </p>

        <div className="space-y-4">
          {modules.map((m) => {
            const p = progress[m.id] || { pct: 0, completed: 0, total: m.lesson_count };
            return (
              <Link
                to={`/modules/${m.id}`}
                key={m.id}
                data-testid={`module-card-${m.id}`}
                className="dw-card group grid md:grid-cols-12 gap-6 p-6 items-center hover:border-[var(--dw-gold)]"
              >
                <div className="md:col-span-1">
                  <div className="font-serif text-5xl text-[var(--dw-gold-soft)]">0{m.id}</div>
                </div>
                <div className="md:col-span-7">
                  <div className="overline mb-1">{m.weight}% of exam · Module {m.id}</div>
                  <div className="font-serif text-2xl text-[var(--dw-navy)] mb-2 leading-tight">{m.title}</div>
                  <div className="text-sm text-neutral-600 mb-3">{m.subtitle}</div>
                  <div className="text-xs text-neutral-500 leading-relaxed line-clamp-2">{m.description}</div>
                </div>
                <div className="md:col-span-3">
                  <div className="flex items-center gap-2 text-xs text-neutral-500 mb-2">
                    <Clock className="w-3.5 h-3.5" strokeWidth={1.5} />
                    ~{m.duration_hours} hours · {m.lesson_count} lessons
                  </div>
                  <div className="h-1 bg-[var(--dw-navy)]/10 rounded-sm overflow-hidden">
                    <div className="dw-progress-bar h-full" style={{ width: `${p.pct}%` }} />
                  </div>
                  <div className="text-xs font-mono-plex text-neutral-600 mt-1.5">{p.completed} / {p.total} complete</div>
                </div>
                <div className="md:col-span-1 flex justify-end">
                  <ArrowRight className="w-5 h-5 text-neutral-400 group-hover:text-[var(--dw-navy)] group-hover:translate-x-1 transition-all" strokeWidth={1.5} />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </AppLayout>
  );
}
